import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { login } from '../containers/User/AuthSlice';

export default function LoginForm() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const from = location.state?.from?.pathname || '/'; // Get the original page or default to home

    const [error, setError] = useState(null);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [submitting, setSubmitting] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault(); // Prevent form from refreshing the page
        setSubmitting(true);
        setError(null);
        try {
            const loginSuccess = await dispatch(login(email, password));

            if (loginSuccess) {
                navigate(from, { replace: true }); // Redirect to the original page
            } else {
                setError('Não foi possível entrar. Verifique os dados e tente de novo.');
            }
        } catch (err) {
            setError('Não foi possível entrar. Tente de novo.');
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', p: 2 }}>
            <Paper variant='outlined' sx={{ p: { xs: 2.5, sm: 4 }, width: '100%', maxWidth: 400 }}>
                <Typography variant='h1' sx={{ mb: 0.5 }}>
                    Entrar
                </Typography>
                <Typography variant='body2' color='text.secondary' sx={{ mb: 3 }}>
                    Backoffice do Disco de Vinil.
                </Typography>

                <Box component='form' onSubmit={handleSubmit} sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                    <TextField
                        label='Email'
                        type='email'
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        fullWidth
                        autoComplete='username'
                        // Phone keyboards otherwise capitalise the first letter and
                        // autocorrect the address into something that will not log in.
                        inputProps={{ autoCapitalize: 'none', autoCorrect: 'off', inputMode: 'email' }}
                    />
                    <TextField
                        label='Palavra-passe'
                        type={showPassword ? 'text' : 'password'}
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                        fullWidth
                        autoComplete='current-password'
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position='end'>
                                    <IconButton
                                        onClick={() => setShowPassword((shown) => !shown)}
                                        edge='end'
                                        aria-label={showPassword ? 'Esconder palavra-passe' : 'Mostrar palavra-passe'}
                                    >
                                        {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }}
                    />

                    {error && <Alert severity='error'>{error}</Alert>}

                    <Button type='submit' variant='contained' size='large' disabled={submitting}>
                        {submitting ? 'A entrar…' : 'Entrar'}
                    </Button>
                </Box>
            </Paper>
        </Box>
    );
}
